<template>
  <div class="fx_chart_pie_container" :ref="ref">
    <!-- <span @click="toEdite()" class="option">编辑</span> -->
    <div class="fx_chart_title" v-if="title" :style="titleStyle">
      {{title}}
      <slot></slot>
    </div>
    <div :style="{'height':`${chartHeight}`}">
      <div class="fx_chart_pie" :ref="chartRef"></div>
    </div>
    <!-- <div class="editor" v-if="showEditor">
      <textarea class="ivu-input" autocomplete="off" v-model="optioForEdite"></textarea>
    </div> -->
  </div>
</template>
<script>
import autoResize from "../../../src/mixins/autoResize";

import { deepClone } from "@jiaminghi/c-render/lib/plugin/util";

import Echarts from "echarts";

export default {
  name: "fxChartPie",
  mixins: [autoResize],
  data() {
    const timestamp = Date.now();
    return {
      title: "",
      titleStyle: "",
      chartHeight: "100%",
      ref: `charts-pie-container-${timestamp}`,
      chartRef: `echart-pie-${timestamp}`,
      echart: null,
      option: {},
      showEditor: false

      // themaColor: this.$store.state.core.themaColor.basetextcolor //从vuex里获取基本文字颜色
    };
  },
  props: {
    config: {
      type: Object,
      default() {
        return {
          option: {
            backgroundColor: "transparent",
            // title: {
            //   text: "Customized Pie",
            //   left: "center",
            //   top: 20,
            //   textStyle: {
            //     color: "red"
            //   }
            // },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },

            visualMap: {
              show: false,
              min: 80,
              max: 600,
              inRange: {
                colorLightness: [0, 1]
              }
            },
            series: [
              {
                name: "访问来源",
                type: "pie",
                radius: "55%",
                center: ["50%", "50%"],
                data: [
                  { value: 335, name: "直接访问" },
                  { value: 310, name: "邮件营销" },
                  { value: 274, name: "联盟广告" },
                  { value: 235, name: "视频广告" },
                  { value: 400, name: "搜索引擎" }
                ].sort(function(a, b) {
                  return a.value - b.value;
                }),
                roseType: "radius",
                label: {
                  color: "rgba(255, 255, 255, 0.3)"
                },
                labelLine: {
                  lineStyle: {
                    color: "rgba(255, 255, 255, 0.3)"
                  },
                  smooth: 0.2,
                  length: 10,
                  length2: 20
                },
                itemStyle: {
                  color: "#c23531",
                  shadowBlur: 200,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                },

                animationType: "scale",
                animationEasing: "elasticOut",
                animationDelay: function(idx) {
                  return Math.random() * 200;
                }
              }
            ]
          }
        };
      }
    }
  },
  computed: {
    optioForEdite() {
      let obj = deepClone(this.option, true);
      return obj;
    }
  },
  watch: {
    "config.option": {
      handler(newVal, oldVal) {
        let { echart, option } = this;
        if (!echart) return;
        // if (!option) option = {};
        option = Object.assign(oldVal, newVal);
        echart.setOption(option, true);
      },
      deep: true
    }
  },
  methods: {
    initEchart() {
      //初始化echarts实例
      const { $refs, chartRef, option } = this;
      const echart = (this.echart = Echarts.init($refs[chartRef]));
      if (!option) return;

      echart.setOption(option);
    },
    afterAutoResizeMixinInit() {
      const { initEchart } = this;
      initEchart();
    },
    onResize() {
      // 自适应
      const { echart } = this;
      if (!echart) return;
      echart.resize();
    },
    getChart(){
      let {echart} = this
      return echart
    },
    toEdite() {
      this.showEditor = !this.showEditor;
    }
  },

  mounted() {
    let { title, titleStyle, option } = this.config;
    if (title) {
      this.title = title;
    }
    if (titleStyle) {
      this.titleStyle = titleStyle;
    }
    if (option) {
      this.option = option;
    }

    if (titleStyle && titleStyle.height) {
      this.chartHeight = `calc( 100% - ${titleStyle.height})`;
    }
    this.$nextTick(() => {
      this.initEchart();
    });
  }
};
</script>
<style lang="scss" scoped>
.fx_chart_pie_container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // position: relative;
  .fx_chart_title {
    color: #000;
    font-size: 16px;
    text-align: left;
    height: 40px;
    line-height: 40px;
  }
  .fx_chart_pie {
    width: 100%;
    height: 100%;
  }
  // .option {
  //   position: absolute;
  //   right: 0;
  //   top: 0;
  //   z-index: 1;
  // }
  // .editor {
  //   width: 400px;
  //   height: 500px;
  //   background: red;
  //   position: absolute;
  //   right: -420px;
  //   top: 0;
  // }
}
</style>